const STRUCT = {
  ID: 'id',
  NAME: 'name',
  GAME_ID: 'game_id',
};

export default STRUCT;
